// extracted by mini-css-extract-plugin
export default {"aglmd-tabs":"YtWRhES_MIbdZqhthBZQ","aglmd-tabs--default":"SPu37wfLYlX7mgxpZkaQ"};